import ArticleLayout from '@/components/base/ArticleLayout';
import { allArticles } from '@/mocks/seoArticles';

export default function StrategieItaobuyPage() {
  return <ArticleLayout data={allArticles['strategie-itaobuy']} />;
}